(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hunna-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hunna-footer')) {
    customElements.define('hunna-footer', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const media = window.matchMedia('(max-width: 749px)');
        const columns = [...this.querySelectorAll('.hf__column')];
        const update = () => columns.forEach(column => {
          column.open = !media.matches;
          column.querySelector('summary').tabIndex = media.matches ? 0 : -1;
        });
        update();
        media.addEventListener('change', update, { signal });
        columns.forEach(column => column.addEventListener('toggle', () => {
          if (!media.matches && !column.open) column.open = true;
        }, { signal }));
        this.querySelector('.hf__cookies')?.addEventListener('click', () => {
          window.privacyBanner?.showPreferences();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const column = columns.find(item => item.dataset.footerBlock === event.detail.blockId);
          if (column) column.open = true;
        }, { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
